import { render, staticRenderFns } from "./Form322_v2.vue?vue&type=template&id=44b56d22&scoped=true&"
import script from "./Form322_v2.vue?vue&type=script&lang=js&"
export * from "./Form322_v2.vue?vue&type=script&lang=js&"
import style0 from "./Form322_v2.vue?vue&type=style&index=0&id=44b56d22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b56d22",
  null
  
)

export default component.exports